import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getActiveDirectoryAuthToken } from "utils/getActiveDirectoryAuthToken";
import { v4 as uuidv4 } from "uuid";
import config from "../../config";

// Base RTK Query API setup for organization service API calls.
export const orgServiceApiSlice = createApi({
  reducerPath: "orgServiceApi",
  baseQuery: fetchBaseQuery({
    // Set the base URL for the orgServiceApi.
    baseUrl: `${typeof config === 'string' ? config : config.organization}/api`,
    // Prepare headers function is used to set the headers for each request to the orgServiceApi.
    prepareHeaders: async (headers, { getState }) => {
      headers.set("Content-Type", "application/json");
      headers.set("x-correlation-id", uuidv4());

      // Fetch fresh authToken from Active Directory and append it to the headers. (Handles token refresh if expired.)
      const authToken = await getActiveDirectoryAuthToken();
      headers.set("Authorization", `Bearer ${authToken}`);
      return headers;
    },
  }),
  // Tag types are used to group endpoints together in the Redux store.
  tagTypes: ["Organization", "Announcement", "CopilotDashboard"],
  endpoints: (builder) => ({}),
});
